var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleNotifyWarn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6198_26066)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#00C31F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26.3542,
    stroke: "#00C31F",
    strokeWidth: 2.29167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.084 12.7188L29.8047 35.1699H26.2168L25.916 12.7188H30.084ZM25.7871 42.002C25.7871 41.3574 25.9805 40.8132 26.3672 40.3691C26.7682 39.9251 27.3555 39.7031 28.1289 39.7031C28.888 39.7031 29.4681 39.9251 29.8691 40.3691C30.2845 40.8132 30.4922 41.3574 30.4922 42.002C30.4922 42.6178 30.2845 43.1478 29.8691 43.5918C29.4681 44.0358 28.888 44.2578 28.1289 44.2578C27.3555 44.2578 26.7682 44.0358 26.3672 43.5918C25.9805 43.1478 25.7871 42.6178 25.7871 42.002Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6198_26066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNotifyWarn);
export default __webpack_public_path__ + "static/media/circle_notify_warn.f94c31eb09476a44638c1a8857766a05.svg";
export { ForwardRef as ReactComponent };